import { string } from 'yup'
import { safify } from '../utils/safify'
import { NewsletterStyles } from 'components/Wizards/Newsletter/NewsletterStyleInput'

export const newsletterStyle = string().default(NewsletterStyles.Promotional).meta({ autoFIll: true }).transform(safify)
